var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWonscoreClientLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 811.227 108.947",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__a",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 1.757 .167)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__b",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 1.517 .073)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__c",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 1.036 -.115)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__d",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 .796 -.209)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__e",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 1.237 -.036)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__f",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 1.124 -.08)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__g",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 .715 -.24)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__h",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 1.052 -.109)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonscore_client_logo_svg__i",
    spreadMethod: "pad",
    gradientTransform: "scale(1226.798 -1226.798) rotate(42.676 .644 -.268)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3580b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e71a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fac911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac911"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1479.3 816.867c62.11-4.203 109.03-57.988 104.8-120.023-4.23-62.086-57.99-109.004-120.06-104.781-62.06 4.222-108.96 57.972-104.75 120.058 4.23 62.055 57.98 108.953 120.01 104.746",
    fill: "url(#wonscore_client_logo_svg__a)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.54 816.867c62.11-4.203 109.03-57.988 104.8-120.023-4.22-62.086-57.99-109.004-120.06-104.781-62.05 4.222-108.95 57.972-104.74 120.058 4.22 62.055 57.97 108.953 120 104.746",
    fill: "url(#wonscore_client_logo_svg__b)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 816.867c62.106-4.203 109.024-57.988 104.793-120.023-4.222-62.086-57.988-109.004-120.058-104.781-62.055 4.222-108.953 57.972-104.746 120.058 4.222 62.055 57.972 108.953 120.011 104.746",
    fill: "url(#wonscore_client_logo_svg__c)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.27 816.867c62.105-4.203 109.023-57.988 104.8-120.023-4.222-62.086-57.988-109.004-120.058-104.781C42.953 596.285-3.945 650.035.266 712.121c4.222 62.055 57.968 108.953 120.004 104.746",
    fill: "url(#wonscore_client_logo_svg__d)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M959.273 20.848c-46.085 34.543-55.445 99.906-20.898 145.988l298.875 398.73c34.54 46.09 99.91 55.446 145.99 20.899 46.09-34.539 55.44-99.906 20.9-145.988L1105.26 41.742c-34.54-46.086-99.9-55.441-145.987-20.894",
    fill: "url(#wonscore_client_logo_svg__e)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M765.781 216.242c-46.082 34.543-55.437 99.906-20.898 145.996l152.414 203.328c34.547 46.09 99.906 55.446 145.993 20.899 46.09-34.539 55.44-99.906 20.9-145.988L911.773 237.141c-34.543-46.086-99.906-55.442-145.992-20.899",
    fill: "url(#wonscore_client_logo_svg__f)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.77 328.164c-46.086 34.547-55.442 99.906-20.899 145.992l68.524 91.41c34.539 46.09 99.902 55.446 145.992 20.899 46.082-34.539 55.437-99.906 20.89-145.988l-68.515-91.414c-34.543-46.083-99.907-55.438-145.992-20.899",
    fill: "url(#wonscore_client_logo_svg__g)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M670.996 643.086c62.106-4.207 109.024-57.988 104.801-120.027-4.231-62.086-57.988-109.004-120.063-104.782-62.05 4.231-108.957 57.973-104.746 120.059 4.227 62.055 57.973 108.961 120.008 104.75",
    fill: "url(#wonscore_client_logo_svg__h)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.367 20.848c-46.086 34.543-55.441 99.906-20.898 145.988l169.07 225.562c34.547 46.082 99.906 55.442 145.992 20.899h.004c46.086-34.547 55.442-99.906 20.895-145.992L425.355 41.742c-34.542-46.086-99.906-55.441-145.988-20.894",
    fill: "url(#wonscore_client_logo_svg__i)",
    fillRule: "evenodd",
    transform: "matrix(.13333 0 0 -.13333 0 108.947)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.816 31.435h9.304l17.823 46.653 19.788-51.24 19.789 51.24 17.821-46.653h9.306L295.52 102.07l-19.79-51.24-19.787 51.24-27.127-70.635M363.664 90.407c14.677 0 25.424-11.14 25.424-25.948 0-14.809-10.747-25.947-25.424-25.947s-25.423 11.138-25.423 25.947c0 14.808 10.746 25.948 25.423 25.948zm0-60.937c19.396 0 35.121 14.808 35.121 34.99 0 20.18-15.725 34.99-35.121 34.99-19.395 0-35.121-14.81-35.121-34.99 0-20.182 15.726-34.99 35.121-34.99M413.985 31.435h9.698v11.14c3.408-7.078 10.878-12.188 21.23-12.188 15.202 0 24.506 10.09 24.506 24.899v42.198h-9.696V57.383c0-11.009-6.554-17.954-17.3-17.954-11.008 0-18.74 7.47-18.74 18.609v39.446h-9.698v-66.05",
    fill: "#100f0d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M492.808 93.926c-3.135-2.37-5.101-5.928-5.908-10.672-.267-1.612.048-2.864.941-3.76.894-.894 2.15-1.343 3.759-1.343 1.521 0 2.639.383 3.355 1.142.717.762 1.298 1.947 1.748 3.558.446 1.88 1.361 3.178 2.752 3.893 1.384.717 3.554 1.074 6.509 1.074h22.016c3.759 0 6.31-.649 7.652-1.947 1.344-1.296 2.015-3.87 2.015-7.72 0-3.846-.671-6.42-2.015-7.717-1.343-1.297-3.893-1.948-7.652-1.948h-21.613c-12.442 0-18.66-6.22-18.66-18.66 0-6.353 1.542-11.052 4.632-14.095 3.089-3.042 7.764-4.565 14.028-4.565h20.942c10.38 0 16.378 4.431 17.988 13.29.268 1.61-.045 2.866-.937 3.76-.899.895-2.15 1.341-3.76 1.341-1.433 0-2.53-.355-3.29-1.073-.76-.716-1.363-1.879-1.81-3.49-.45-1.611-1.299-2.706-2.55-3.29-1.257-.58-3.135-.872-5.64-.872h-20.943c-3.582 0-5.972.583-7.183 1.746-1.205 1.163-1.81 3.58-1.81 7.249 0 3.49.605 5.862 1.81 7.114 1.21 1.255 3.601 1.88 7.183 1.88h21.613c6.532 0 11.388 1.59 14.567 4.766 3.176 3.178 4.764 8.034 4.764 14.564 0 6.535-1.588 11.392-4.764 14.567-3.179 3.178-8.035 4.766-14.567 4.766h-22.016c-5.636 0-10.024-1.185-13.156-3.558M565.77 91.24c-4.163-4.16-6.245-10.581-6.245-19.264V56.538c0-8.77 2.082-15.213 6.244-19.33 4.163-4.115 10.582-6.13 19.264-6.042h11.008c6.622 0 11.792 1.12 15.506 3.356 3.713 2.238 6.018 5.685 6.913 10.337.268 1.611-.045 2.866-.941 3.76-.895.895-2.192 1.341-3.892 1.341-1.342 0-2.371-.355-3.088-1.073-.716-.716-1.342-1.833-1.88-3.357-.624-1.698-1.9-2.906-3.826-3.625-1.926-.715-4.853-1.073-8.792-1.073h-11.008c-4.117-.088-7.294.358-9.53 1.343-2.24.986-3.85 2.596-4.834 4.832-.985 2.238-1.477 5.416-1.477 9.531v15.438c0 4.118.492 7.297 1.477 9.533.984 2.237 2.594 3.848 4.834 4.833 2.236.985 5.413 1.476 9.53 1.476h11.008c3.939 0 6.866-.357 8.792-1.074 1.926-.715 3.202-1.924 3.826-3.625.538-1.52 1.164-2.638 1.88-3.355.717-.716 1.79-1.074 3.224-1.074 1.609 0 2.861.448 3.756 1.341.896.896 1.209 2.148.941 3.76-.895 4.655-3.2 8.1-6.913 10.336-3.714 2.238-8.884 3.357-15.506 3.357h-11.008c-8.682 0-15.101-2.082-19.264-6.243M665.98 87.818c4.116 0 7.295-.49 9.53-1.476 2.238-.985 3.85-2.596 4.834-4.833.985-2.236 1.477-5.415 1.477-9.533V56.674c0-4.116-.492-7.294-1.477-9.532-.984-2.237-2.596-3.847-4.833-4.833-2.236-.984-5.415-1.477-9.531-1.477h-11.008c-4.117 0-7.296.47-9.53 1.41-2.238.94-3.85 2.55-4.831 4.833-.99 2.282-1.479 5.483-1.479 9.599V72.11c0 4.027.49 7.162 1.479 9.398.981 2.237 2.593 3.848 4.83 4.833 2.235.985 5.414 1.476 9.531 1.476zm-30.272 3.49c-4.16-4.114-6.243-10.515-6.243-19.197V56.674c0-8.77 2.059-15.214 6.176-19.332 4.116-4.116 10.559-6.176 19.331-6.176h11.008c8.77 0 15.213 2.06 19.333 6.176 4.114 4.118 6.175 10.561 6.175 19.332v15.302c0 8.683-2.061 15.104-6.175 19.265-4.12 4.161-10.562 6.243-19.333 6.243h-11.008c-8.683 0-15.103-2.059-19.264-6.175M745.788 32.442c.85.852 1.276 2.036 1.276 3.557 0 1.524-.425 2.709-1.276 3.558-.85.852-2.037 1.275-3.557 1.275-8.055 0-14.21 1.657-18.458 4.967-4.253 3.312-6.377 7.876-6.377 13.693V92.65c0 1.523-.425 2.709-1.276 3.558-.85.852-2.037 1.276-3.557 1.276-1.523 0-2.71-.424-3.559-1.276-.85-.85-1.275-2.035-1.275-3.558V36c0-1.52.424-2.705 1.275-3.557.85-.85 2.036-1.276 3.559-1.276 1.52 0 2.706.427 3.557 1.276.85.852 1.276 2.036 1.276 3.557v7.115c2.595-3.937 5.995-6.914 10.203-8.927 4.205-2.014 9.081-3.02 14.632-3.02 1.52 0 2.706.426 3.557 1.275M758.879 58.552h42.688v-1.878c0-4.116-.492-7.294-1.476-9.532-.986-2.237-2.598-3.847-4.834-4.833-2.237-.984-5.416-1.477-9.532-1.477h-11.008c-4.116-.088-7.294.358-9.532 1.343-2.237.986-3.848 2.616-4.83 4.9-.987 2.282-1.476 5.483-1.476 9.599zm0 9.667v3.892c0 4.027.489 7.162 1.476 9.398.982 2.237 2.593 3.848 4.83 4.833 2.238.985 5.416 1.476 9.532 1.476h11.008c5.012 0 8.679-.537 11.008-1.61 2.326-1.075 3.803-2.954 4.431-5.64.356-1.52.917-2.661 1.677-3.423.762-.758 1.9-1.141 3.424-1.141 1.612 0 2.842.427 3.692 1.275.85.853 1.142 2.082.874 3.692-.895 5.638-3.403 9.8-7.52 12.485-4.116 2.684-9.979 4.028-17.586 4.028h-11.008c-8.682 0-15.102-2.059-19.265-6.175-4.16-4.115-6.24-10.516-6.24-19.198V56.674c0-8.77 2.08-15.237 6.24-19.4 4.163-4.162 10.583-6.196 19.265-6.108h11.008c8.772 0 15.215 2.06 19.334 6.176 4.113 4.118 6.174 10.561 6.174 19.332v6.711c0 1.523-.426 2.708-1.276 3.559-.85.85-2.037 1.275-3.557 1.275h-47.521",
    fill: "#3580b7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWonscoreClientLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wonscore_client_logo.e50d0d85db38f61e589edc89f25ddb79.svg";